export const paramRegex = /\/(:([^\/?]*)\??)/g;
export const optionalRegex = /(\/:[^\/]*\?)$/g;